/* eslint-disable */
import _ from 'lodash'
import {Request} from '../shared/base.requests'
import config from '../../config/customer.api' 
import * as qs from "qs"
import { mapActions } from 'vuex';
import {appInsights} from '../shared/applicationInsights'


const brochureModule = {
  namespaced: true,
  state: {
    makes:[],
    models:[],
    years:[],
    brochures:[],
    brochureHistory:[],
  },
  mutations: {
    setMakes (state, payload) {
      state.makes = payload;    
    },
    setHistory (state, payload) {
      state.brochureHistory = payload;    
    },
    setModels (state, payload) {
      state.models = payload;    
    },
    setYears (state, payload) {
      state.years = payload;    
    },
    setBrochures (state, payload) {
      state.brochures = payload;    
    },
  },
  actions: {
    loadBrochureMakes: function (context) {
      context.commit('setModels', []);
      context.commit('setYears', []);
      context.commit('setBrochures', []);
      
      return new Promise((resolve, reject) => {
        Request.get(config.getBrochureMakes)
        .then(response => {           
          context.commit('setMakes', response);
          resolve();
        })
        .catch(error => {
          console.error('setMakes failed', error);
          reject()
        })
      })
    },
    loadBrochureHistory: function (context) {      
      return new Promise((resolve, reject) => {
        let apiUrl = config.loadBrochureHistory;
        Request.get(apiUrl)
        .then(response => {           
          context.commit('setHistory', response);
          resolve();
        })
        .catch(error => {
          appInsights.trackException({ exception: error, message: error.message, properties:  { 'apiUrl': apiUrl, 'accessId': localStorage.accessId}});
          appInsights.flush();

          reject()
        })
      })
    },
    loadBrochureModels: function (context,payload) {
      context.commit('setYears', []);
      context.commit('setBrochures', []);

      return new Promise((resolve, reject) => {
        let apiUrl = config.getBrochureModels+"/?make="+payload.make;
        Request.get(apiUrl)
        .then(response => {           
          context.commit('setModels', response);        
          resolve();
        })
        .catch(error => {
          appInsights.trackException({ exception: error, message: error.message, properties:  { 'apiUrl': apiUrl, 'accessId': localStorage.accessId}});
          appInsights.flush();

          console.error('setCustomer failed', error);
          reject()
        })
      })
    },
    loadBrochureYears: function (context,payload) {
      context.commit('setBrochures', []);
      
      return new Promise((resolve, reject) => {
        let apiUrl = config.getBrochureYears+"/?make="+payload.make+"&model="+payload.model;
        Request.get(apiUrl)
        .then(response => {           
          context.commit('setYears', response);  
          resolve();
          let apiUrl = config.getBrochures+"/?make="+payload.make+"&model="+payload.model+"&year="+payload.year;
          Request.get(apiUrl)
          .then(response => {           
            console.log(response);
            context.commit('setBrochures', response);        
            resolve();
          })
          .catch(error => {
            appInsights.trackException({ exception: error, message: error.message, properties:  { 'apiUrl': apiUrl, 'accessId': localStorage.accessId}});
            appInsights.flush();

            console.error('setCustomer failed', error);
            reject()
          })
        })
        .catch(error => {
          appInsights.trackException({ exception: error, message: error.message, properties:  { 'apiUrl': apiUrl, 'accessId': localStorage.accessId}});
          appInsights.flush();

          console.error('setCustomer failed', error);
          reject()
        })
      })
    },
    loadBrochures: function (context,payload) {
      console.log(payload);
      return new Promise((resolve, reject) => {
        let apiUrl = config.getBrochures+"/?make="+payload.make+"&model="+payload.model+"&year="+payload.year;
        Request.get(apiUrl)
        .then(response => {           
          console.log(response);
          context.commit('setBrochures', response);        
          resolve();
        })
        .catch(error => {
          appInsights.trackException({ exception: error, message: error.message, properties:  { 'apiUrl': apiUrl, 'accessId': localStorage.accessId}});
          appInsights.flush();

          console.error('setCustomer failed', error);
          reject()
        })
      })
    },
    addBrochure: function (context,payload) {
      return new Promise((resolve, reject) => {
        let apiUrl = config.addBrochure+"/?make="+payload.make+"&model="+payload.model+"&year="+payload.year+"&submodel="+payload.submodel;
        Request.get(apiUrl)
        .then(response => {           
          resolve();
        })
        .catch(error => {
          appInsights.trackException({ exception: error, message: error.message, properties:  { 'apiUrl': apiUrl, 'accessId': localStorage.accessId}});
          appInsights.flush();

          reject()
        })
      })
    }
  },
  getters: {
    getBrochures: state => {
      return state.brochures;
    },
    getMakes: state => {
      return state.makes;
    },
    getModels: state => {
      return state.models;
    },
    getYears: state => {
      return state.years;
    },

  },   
}

export default brochureModule



// WEBPACK FOOTER //
// ./scripts/src/store/brochure.module.js